<template>
  <div class="label-wrapper mb-1">
    <span class="first-label">
      <a class="label-link" :href="'#/'+link">{{linkLabel}}</a>
      <slot name="firstLabel" ><span v-html="firstLabel"></span></slot>
      <span v-if="!twoLines">
        &ndash;
      </span>
    </span>
    <br v-if="twoLines"/>
    <span class="second-label">
      <slot name="secondLabel"><span v-html="secondLabel"></span></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "TwoLabel",
  props: {
    linkLabel: String,
    firstLabel: String,
    secondLabel: String,
    twoLines: Boolean,
    link: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.first-label {
  font-weight: bold;
}
.label-wrapper {
  font-size: 18px;
}
</style>
